import axios from "axios";
import Config from "src/config";

const BASE = Config.dev ? Config.url_dev : Config.urlBackend;

export const listMktAccounts = (clienteId, querys) => {
    return axios({
        method: "get",
        url: `${BASE}/api/v2/${clienteId}/mkt/accounts${querys || ''}`
    });
};

export const getMktAccount = (id) => {
    return axios({
        method: "get",
        url: `${BASE}/api/v2/mkt/accounts/${id}`
    });
};

export const createMktAccount = (clienteId, data) => {
    return axios({
        method: "post",
        url: `${BASE}/api/v2/${clienteId}/mkt/accounts`,
        data
    });
};

export const updateMktAccount = (clienteId, id, data) => {
    return axios({
        method: "put",
        url: `${BASE}/api/v2/${clienteId}/mkt/accounts/${id}`,
        data
    });
};

export const deleteMktAccount = (clienteId, id) => {
    return axios({
        method: "delete",
        url: `${BASE}/api/v2/${clienteId}/mkt/accounts/${id}`
    });
};

export const syncMktAccount = (id) => {
    return axios({
        method: "post",
        url: `${BASE}/api/v2/mkt/accounts/${id}/sync`
    });
};

// OAuth - Meta
export const exchangeMetaCode = (clienteId, data) => {
    return axios({
        method: "post",
        url: `${BASE}/api/v2/${clienteId}/mkt/auth/meta/exchange`,
        data
    });
};

export const connectMetaAccount = (clienteId, data) => {
    return axios({
        method: "post",
        url: `${BASE}/api/v2/${clienteId}/mkt/auth/meta/connect`,
        data
    });
};
